import * as React from "react";
import { forwardRef } from "react";
const SvgIcError24 = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M12.2501 14.3713L18.4395 20.5607L20.5608 18.4393L14.3714 12.25L20.5608 6.06065L18.4395 3.93933L12.2501 10.1287L6.06077 3.93933L3.93945 6.06065L10.1288 12.25L3.93947 18.4393L6.06079 20.5607L12.2501 14.3713Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgIcError24);
export { ForwardRef as ReactComponent };
